var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSumHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 93.644 126.253",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5655",
    transform: "translate(-476.803 -1766.876)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 207",
    cx: 37.489,
    cy: 3.491,
    rx: 37.489,
    ry: 3.491,
    transform: "translate(486.149 1886.147)",
    fill: "#3db0f7",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 476"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2026",
    d: "M570.446 1811.047c0-24.395-20.95-44.171-46.793-44.171s-46.793 19.776-46.793 44.171c0 0-3.613 29.088 46.612 77.928 45.871-44.316 47.125-72.369 46.964-77.185.005-.248.01-.495.01-.743zm-46.974 28.011a28.73 28.73 0 1128.907-28.729 28.818 28.818 0 01-28.907 28.729z",
    fill: "#00AFF0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2027",
    d: "M570.295 1811.047c0-24.395-20.95-44.171-46.793-44.171h-.181v14.722a28.73 28.73 0 110 57.458v49.92c45.871-44.316 47.125-72.369 46.964-77.185.004-.249.01-.496.01-.744z",
    fill: "#00AFF0"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Home",
    d: "M537.453 1804.438l-12.687-9.188a1.312 1.312 0 00-1.542 0l-12.677 9.188a1.312 1.312 0 00-.547 1.062v16.186a1.312 1.312 0 001.312 1.314h25.376a1.312 1.312 0 001.312-1.314V1805.5a1.313 1.313 0 00-.547-1.061zm-16.078 15.936v-7.874h5.25v7.875zm14 0h-6.125v-9.188a1.313 1.313 0 00-1.313-1.313h-7.875a1.313 1.313 0 00-1.312 1.313v9.188h-6.125v-14.208L524 1797.93l11.375 8.236z",
    fill: "#00AFF0",
    opacity: 0.75
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSumHome);
export default __webpack_public_path__ + "static/media/sum_home.43b4575473acf45ddc4f96a3106a3dac.svg";
export { ForwardRef as ReactComponent };